import { useState } from 'react';
import { scale } from '@components/frame';
import { useImageHandlingChecks } from '@v2/components/imageHandling/hooks/useImageHandlingChecks';
import { useManageImageHandlingHeaderActions } from '@v2/components/imageHandling/components/Header/hooks/useManageImageHandlingHeaderActions';
import { MobileBottomTabsProps } from '@v2/components/imageHandling/components/MobileBottomTabs';
import { StyleProp, ViewStyle } from 'react-native';
import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';
import { useAnnotationModeEnabled } from '@v2/components/imageHandling/components/DrawingCanvas/hooks';

interface UseManageMobileBottomTabsParams extends Pick<MobileBottomTabsProps, 'C' | 'images' | 'selectedIndex' | 'cropImage'> {}

export const useManageMobileBottomTabs = ({ C, images, selectedIndex, cropImage }: UseManageMobileBottomTabsParams) => {
  const { showInfoPopUp, showRotatePopUp, triggerCrop, triggerInfoPopUp, triggerRotatePopUp, showCrop, } = useManageImageHandlingHeaderActions({
    images,
    selectedIndex,
  });

  const { isSingleImage } = useImageHandlingChecks({ images });
  const isAnnotationModeEnabled = useAnnotationModeEnabled();

  const img = images[selectedIndex] ?? null;

  const iconContainerSize = 44;

  const hoveredStyle = (hovered: boolean, pressed: boolean, isModalOpen: boolean = false): StyleProp<ViewStyle> => {
    return {
      width: scale(iconContainerSize),
      height: scale(iconContainerSize),
      backgroundColor: pressed || isModalOpen ? C('Button/Light/Only Text pressed') : hovered ? C('Gray/Light/5') : 'transparent',
      borderRadius: scale(iconContainerSize) / 2,
      justifyContent: 'center',
      alignItems: 'center',
    };
  };

  const [showAttachModal, setShowAttachModal] = useState(false);

  const openAttachModal = () => {
    setShowAttachModal(true);
  };

  const closeAttachModal = () => setShowAttachModal(false);

  const onSaveCrop = (image: ImageDocumentStoreItem) => {
    triggerCrop();
    cropImage(image);
  };

  return {
    isAnnotationModeEnabled,
    showInfoPopUp,
    showRotatePopUp,
    triggerCrop,
    triggerInfoPopUp,
    triggerRotatePopUp,
    isSingleImage,
    img,
    hoveredStyle,
    showAttachModal,
    setShowAttachModal,
    openAttachModal,
    closeAttachModal,
    iconContainerSize,
    onSaveCrop,
    showCrop,
  };
};
